/**
 * True on viewports wide enough for a docked detail drawer.
 *
 * Lifted out of `RequirementDrawer` once a second and third drawer needed the
 * same breakpoint. Deliberately NOT `useWideViewport`, which owns a different
 * one (1280px, the chat dock).
 */

import { useEffect, useState } from 'react'

/** Below this the two-column layout collapses and a sheet takes over. */
export const DESKTOP_QUERY = '(min-width: 1024px)'

export function useIsDesktop(query: string = DESKTOP_QUERY): boolean {
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia
      ? window.matchMedia(query).matches
      : false
  )

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const handler = (e: MediaQueryListEvent) => setIsDesktop(e.matches)
    setIsDesktop(mql.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return isDesktop
}
